// Manages transmission of messages
// hanldes pictures which require upload
// and messages that don't
// Stores pending messages in browser storage
// Hands off actual transmission to a backend transmissionExecutor
// can be PWA or Android backend for actual transmission
// No callbacks because needs to persist state even after webview is unloaded

// Transmission log - local log
//  must be contained in browser storage
//  used to get list of pending messages

// Transmission queue - maintained by transmissionExecutor

function _openDB () {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('transmissionManagerDb', 1)

    request.onupgradeneeded = () => {
      const db = request.result
      if (!db.objectStoreNames.contains('pendingMessages')) {
        const store = db.createObjectStore('pendingMessages', {
          keyPath: 'txnId'
        })
        // index used to return records in insertion order
        store.createIndex('createdAt', 'createdAt')
      }
    }
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}

async function logout () {
  console.log('RJMDEBUG001 TransmissionManager logout start')
  const db = await _openDB()
  const tx = db.transaction('pendingMessages', 'readwrite')
  const store = tx.objectStore('pendingMessages')
  store.clear()
  console.log('RJMDEBUG001 TransmissionManager logout end')
}

async function _addMessageToTransmissionLog ({ txnId, processData, roomId, messageType, content }) {
  const db = await _openDB()
  const tx = db.transaction('pendingMessages', 'readwrite')
  const store = tx.objectStore('pendingMessages')
  let mainType = 'unknown'
  if (typeof (content) !== 'undefined') {
    if (typeof (content.msgtype) !== 'undefined') {
      mainType = content.msgtype
    }
  }
  const data = { type: mainType, txnId, processData, roomId, messageType, content, status: 'sending' }
  const record = { txnId, data, createdAt: Date.now() }
  store.put(record)
}

async function sendMessage ({ txnId, processData, roomId, messageType, content }) {
  _addMessageToTransmissionLog({ txnId, processData, roomId, messageType, content })
  // _addMessageToTransmissionQueue not here - implemented in the chat store in sendEvent
  // _addMessageToTransmissionQueue({ txnId, processData, roomId, messageType, content })
}

async function getPendingMessageList () {
  const db = await _openDB()
  return new Promise((resolve, reject) => {
    const tx = db.transaction('pendingMessages', 'readonly')
    const store = tx.objectStore('pendingMessages')
    const index = store.index('createdAt')

    const items = []
    const req = index.openCursor()

    req.onsuccess = () => {
      const cursor = req.result
      if (cursor) {
        items.push(cursor.value)
        cursor.continue()
      } else {
        resolve(items)
      }
    }

    req.onerror = () => reject(req.error)
  })
}

async function registerTransmissionComplete ({ success, txnId, roomId }) {
  // console.log('RJMDEBUG001 transmission manager registerTransmissionComplete', success, txnId, roomId)
  const db = await _openDB()

  return new Promise((resolve, reject) => {
    const tx = db.transaction('pendingMessages', 'readwrite')
    const store = tx.objectStore('pendingMessages')

    tx.oncomplete = () => {
      // console.log('RJMDEBUG001 transaction committed')
      resolve()
    }
    tx.onerror = () => {
      console.error('RJMDEBUG001 ERROR transaction failed', tx.error)
      reject(tx.error)
    }
    tx.onabort = () => {
      console.error('RJMDEBUG001 ERROR transaction aborted', tx.error)
      reject(tx.error)
    }

    if (success) {
      // Successful: delete the record
      const req = store.delete(txnId)
      req.onsuccess = () => {
        // console.log('RJMDEBUG001 delete request success')
      }
      req.onerror = () => {
        console.log('RJMDEBUG001 ERROR delete request errored')
        reject(req.error)
      }
    } else {
      // Failed: update its status
      // console.log('RJMDEBUG001 transmissionManager registerTransmissionComplete failed', txnId)

      const getReq = store.get(txnId)
      getReq.onerror = () => reject(getReq.error)

      getReq.onsuccess = () => {
        const record = getReq.result
        if (!record) {
          // Nothing to update, just resolve
          // return resolve() no need to resolve transaction will resolve
          return
        }

        record.data.status = 'failed'
        // console.log('storign new record', record)

        const putReq = store.put(record)
        putReq.onsuccess = () => {
          // console.log('RJMDEBUG001 put request success')
        }
        putReq.onerror = () => {
          console.log('RJMDEBUG001 ERROR put request errored')
          reject(putReq.error)
        }
      }
    }
  })
}

async function registerTransmissionDiscarded ({ txnId }) {
  const db = await _openDB()

  return new Promise((resolve, reject) => {
    const tx = db.transaction('pendingMessages', 'readwrite')
    const store = tx.objectStore('pendingMessages')
    const req = store.delete(txnId)
    req.onsuccess = () => resolve()
    req.onerror = () => reject(req.error)
  })
}

async function registerTransmissionRetry ({ txnId }) {
  const db = await _openDB()

  return new Promise((resolve, reject) => {
    const tx = db.transaction('pendingMessages', 'readwrite')
    const store = tx.objectStore('pendingMessages')

    // Failed: update its status
    // console.log('RJMDEBUG001 transmissionManager registerTransmissionComplete failed', txnId)

    const getReq = store.get(txnId)
    getReq.onerror = () => reject(getReq.error)

    getReq.onsuccess = () => {
      const record = getReq.result
      if (!record) {
        // Nothing to update, just resolve
        return resolve()
      }

      record.data.status = 'sending'
      // console.log('storign new record', record)

      const putReq = store.put(record)
      putReq.onsuccess = () => resolve()
      putReq.onerror = () => reject(putReq.error)
    }
  })
}

export default {
  sendMessage,
  logout,
  getPendingMessageList,
  registerTransmissionComplete,
  registerTransmissionDiscarded,
  registerTransmissionRetry
}
